module.exports = __webpack_public_path__ + "media/images/admin/icons/folder-minus-dcd0d0f5c98a46e74f2ca50607c6d674.svg";